<template>
  <v-card flat>
    <v-card-title class="title-font pb-1 pt-0" style="font-size: medium">
      <v-icon
        :color="files.length === 2 ? 'success' : 'error'"
        class="ml-n3 mr-2"
        small
      >
        {{ files.length === 2 ? "mdi-check-circle" : "mdi-close-circle" }}
      </v-icon>
      {{ categoryTitle }}
      <small v-if="categorySubtitle" class="ml-3">
        {{ categorySubtitle }}
      </small>
    </v-card-title>
    <v-card-subtitle class="error--text ml-3" v-if="error">
      Required
    </v-card-subtitle>
    <v-card-text class="pb-2">
      <v-row v-if="files.length">
        <v-col
          v-for="(file, index) in files"
          :key="index"
          cols="6"
          class="px-2 pb-0"
        >
          <v-badge
            overlap
            color="red"
            :value="!file.uploaded || scanUploadError"
            style="display: block; width: 100%"
            small
          >
            <template slot="badge">
              <v-icon @click="deleteFile(index)">mdi-close</v-icon>
            </template>
            <v-card flat outlined class="rounded-10">
              <ModelViewer
                :filename="file.file.name"
                :url="file.getObjectUrl()"
              />
              <v-card-text class="px-1 py-1 text-center">
                <v-chip small>
                  <small class="d-inline-block text-truncate">
                    {{ file.file.name }}
                  </small>
                </v-chip>
              </v-card-text>
            </v-card>
          </v-badge>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="px-0">
          <FileUploader
            @addFiles="addFiles"
            text="Upload"
            :fileExtension="permittedExtensions"
            :category="category"
            :disabled="disabled"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"
import ModelViewer from "@/components/HomePage/MainCard/UploadScans/ScanUploader/ModelViewer.vue"
import FileUploader from "@/components/HomePage/MainCard/UploadScans/ScanUploader/FileUploader.vue"

export default {
  name: "NewOrderScanUploader",

  props: ["value", "categoryTitle", "category", "categorySubtitle", "disabled"],

  inject: ["form"],

  components: { FileUploader, ModelViewer },

  data() {
    return {
      error: null,
      valid: true
    }
  },

  computed: {
    ...mapGetters(["scanUploadError"]),
    files: {
      get() {
        return this.value
      },

      set(value) {
        if (value) {
          this.error = null
        }
        this.$emit("input", value)
      }
    },

    permittedExtensions() {
      return ["stl", "ply"]
    }
  },

  methods: {
    validate() {
      if (!this.files.length === 2) {
        this.error = "Must upload two files"
        this.valid = false
      } else this.valid = true
      return this.valid
    },

    addFiles(addedFiles) {
      this.files = [...this.files, ...addedFiles]
    },

    deleteFile(index) {
      this.files[index].revokeObjectUrl()
      this.files.splice(index, 1)
    }
  },

  created() {
    this.form.register(this)
  }
}
</script>
